import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HealthService } from '../../../services/health.service';
import { Datapoint, Series, GraphObj } from './dataPoint';
import { HealthGraphDataService } from 'src/app/services/health-graph-data.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-view-health',
  templateUrl: './view-health.component.html',
  styleUrls: ['./view-health.component.css']

})
export class ViewHealthComponent implements OnInit , OnDestroy {
  id: number;
  private sub: any;
  healthDetails: any = {};
  health_payload: any[] = [];
  obj: Datapoint;
  drawGraph = false;

  graphArray: any = [];
  view: any[] = [700, 400];

  // options
  showXAxis;
  showYAxis;
  gradient;
  showLegend;
  showXAxisLabel;
  xAxisLabel;
  showYAxisLabel;
  yAxisLabel;
  multi;
  legendTitle;

  colorScheme = {
    domain: ['#5AA454', '#A10A28', '#C7B42C', '#00FFFF']
  };

  // line, area
  autoScale = true;
  newData: any;
  finalArray;
  source: number;
  componentDetails: any;
  subscriptions: Subscription[] = [];

  constructor(private activatedRoute: ActivatedRoute,
    private healthService: HealthService, private router: Router,
    private healthgraphdata: HealthGraphDataService, private zone: NgZone) {

    setInterval(() => {

      this.getStatusEvery2Mins();
     this.subscriptions.push( this.healthgraphdata.getGraphData().subscribe(res => {
        this.finalArray = res;
      }));
    }, 120 * 1000);

  }

  ngOnInit() {

    this.sub = this.activatedRoute.params.subscribe(params => {
      this.id = +params['id'];
      this.source = params['source'];
     this.subscriptions.push( this.healthService.getComponentDetails(this.id, this.source.toString())
        .subscribe(res => {
          this.healthDetails = res;
        }));
     this.subscriptions.push( this.healthService.getComponentOnehourData(this.id, this.source.toString())
        .subscribe(data => {
          this.createDataPoints(data);
          this.drawGraphWithData();


        }));
    });



  }
  ngOnDestroy() {
    // prevent memory leak when component destroyed
 this.subscriptions.forEach(s => s.unsubscribe());
  }

  drawGraphWithData() {

    this.drawGraph = true;
      this.showXAxis = true;
    this.showYAxis = true;
    this.gradient = false;
    this.showLegend = true;
    this.showXAxisLabel = true;
    this.xAxisLabel = 'Time';
    this.showYAxisLabel = true;
    this.yAxisLabel = 'Value';
    this.legendTitle = 'System HEalth';


  }



  createDataPoints(data) {
    this.componentDetails = data;
    this.componentDetails.cluster.forEach(cluster => {
      const dataForGraph: any = [];
      if (typeof Object.keys(cluster) !== 'undefined' && Object.keys(cluster).length > 0) {
        Object.keys(cluster).forEach(ip => {
          if (typeof Object.keys(ip) !== 'undefined' && Object.keys(ip).length > 0) {
            Object.keys(cluster[ip]).forEach(time => {
              if (typeof Object.keys(cluster[ip][time]) !== 'undefined' && Object.keys(cluster[ip][time]).length > 0) {
                Object.keys(cluster[ip][time]).forEach(reading => {
                  const readingKey = cluster[ip][time][reading];
                  if (typeof Object.keys(readingKey) !== 'undefined' && Object.keys(readingKey).length > 0) {
                    if (reading === 'reading') {
                      Object.keys(readingKey).forEach(keyee => {

                        // inner iteration starts here
                        const seriesobj: any = [];
                        if (dataForGraph.length !== 0) {
                          const checkObjectAlreadyExists = value => dataForGraph.some(({ name }) => name === value);
                          if (checkObjectAlreadyExists(keyee)) {

                            dataForGraph.find(x => x.name === keyee).series.push(new Series(time,
                              cluster[ip][time]['reading'][keyee].value));
                          } else {

                            seriesobj.push(new Series(time, cluster[ip][time]['reading'][keyee].value));
                            dataForGraph.push(new Datapoint(keyee, seriesobj));

                          }
                        } else {
                          seriesobj.push(new Series(time, cluster[ip][time]['reading'][keyee].value));
                          dataForGraph.push(new Datapoint(keyee, seriesobj));
                        }
                        // inner iteration ends here

                      });

                    }
                  }
                });
              }
            });
          }
          this.graphArray.push(new GraphObj(ip, dataForGraph));

        });
      }

    });

    this.finalArray = this.graphArray;
  }


  getStatusEvery2Mins() {
    // const tempArray = this.graphArray;
   this.subscriptions.push( this.healthService.getStatusEvery2Secs(this.id, this.source.toString())
      .subscribe(res => {
        this.newData = res;
        this.newData.cluster.forEach(cluster => {
          if (typeof Object.keys(cluster) !== 'undefined' && Object.keys(cluster).length > 0) {
            Object.keys(cluster).forEach(ip => {
              const current_cluster = this.graphArray.find(x => x.name === ip);
              current_cluster.data.forEach(graph_data => {

                if (typeof Object.keys(ip) !== 'undefined' && Object.keys(ip).length > 0) {
                  Object.keys(cluster[ip]).forEach(time => {
                    if (typeof Object.keys(cluster[ip][time]) !== 'undefined' && Object.keys(cluster[ip][time]).length > 0) {
                      Object.keys(cluster[ip][time]).forEach(reading => {
                        const readingKey = cluster[ip][time][reading];
                        if (typeof Object.keys(readingKey) !== 'undefined' && Object.keys(readingKey).length > 0) {
                          if (reading === 'reading') {
                            Object.keys(readingKey).forEach(keyee => {
                              if (graph_data.name === keyee) {
                                graph_data.series.push(new Series(time, cluster[ip][time]['reading'][keyee].value));

                              }
                              while (graph_data.series.length > 30) {
                                graph_data.series.shift();
                              }
                            });
                          }
                        }
                      });

                    }

                  });
                }


              });
            });
          }

        });
        this.healthgraphdata.setGraphData(this.graphArray);

      }));

  }


  goBacktoList() {
    this.router.navigate(['../../../list'], { relativeTo: this.activatedRoute });
  }


}


